import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const CreateSports = () => {
  return (
    <Create
      title="Създаване на спорт"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateSports;
